import React from 'react'
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Features from "./components/features/Features";
import Home from './Home';
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';

const routes = () => {
  return (
    <>
    <ScrollToTop />
    <Routes> 
      <Route path='/' element={<Home />} />
      <Route path='/projects' element={<ProjectsPage />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path='/services' element={<ServicesPage />} />
      <Route path='/contact' element={<ContactPage />} />
      <Route path='/Service' element={<Features />} />
    </Routes>
    </>
  )
}

export default routes
